import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	TranslatedString,
	Dropdown,
	Card,
	Form,
	PrimaryButton,
	useAjax,
	XhrStatus,
	Link,
	FileDownload
} from '@bosch/bt-ui';

import './DownloadBillingReport.css';
import withErrorHandler from '../../../components/ErrorHandler';


const DownloadBillingReport = (props) => {
	const {
		token
	} = props;
	const [selectedYear, setSelectedYear] = useState('2020');
	const [selectedMonth, setSelectedMonth] = useState('8');
	const months = [
		{ label: 'Jan', value: '1' },
		{ label: 'Feb', value: '2' },
		{ label: 'Mar', value: '3' },
		{ label: 'Apr', value: '4' },
		{ label: 'May', value: '5' },
		{ label: 'Jun', value: '6' },
		{ label: 'Jul', value: '7' },
		{ label: 'Aug', value: '8' },
		{ label: 'Sep', value: '9' },
		{ label: 'Oct', value: '10' },
		{ label: 'Nov', value: '11' },
		{ label: 'Dec', value: '12' }
	];
	const years = [
		{ label: '2018', value: '2018' },
		{ label: '2019', value: '2019' },
		{ label: '2020', value: '2020' },
		{ label: '2021', value: '2021' }
	];
	const [result, status, getBillingReport, response] = useAjax(XhrStatus.Initial);
	useEffect(() => {
		if (status === XhrStatus.Finished) {
			consolg.log(status);
			consolg.log(result);
			consolg.log(response);
		}
	}, [status, result, response]);

	return (
		<Card
			htmlAttributes={{
				id: 'download-billing-report',
				className: 'download-billing-report'
			}}
		>
			<h3>Download Billing Report</h3>

			<div className="dropdown-item">
				<Dropdown
					fieldName="selectedYear"
					label="Year"
					options={years}
					htmlAttributes={{
						onChange: update => {
							setSelectedYear(update.value);
						},
						value: selectedYear,
					}}
					reactSelectOptions={{ menuPlacement: 'auto' }}
				/>

				<Dropdown
					fieldName="selectedMonth"
					label="Month"
					options={months}
					reactSelectOptions={{ menuPlacement: 'auto' }}
					htmlAttributes={{
						onChange: update => {
							setSelectedMonth(update.value);
						},
						value: selectedMonth,
					}} />
				<Link
					href={SUPPORTCONSOLE_API_URL + '/api/siminformation/v1/downloadbillingreport/' + encodeURIComponent(selectedYear) + '/' + encodeURIComponent(selectedMonth)}
					linkType="button"
					areOriginAndDestinationPagesBothReactOnly={false}
				>
					<TranslatedString
						stringId="Download"
					/>
				</Link>
			</div>
		</Card>
	);
};

export default withErrorHandler(React.memo(DownloadBillingReport));